import api from "../api/axios";

const WorkTrackingAnalyticsService = {
  track: async (event) => {
    try {
      const response = await api.post("/work-tracking-analytics/events", event);
      return response.data;
    } catch (error) {
      // Ölçümleme, ana iş takibi deneyimini hiçbir zaman engellememeli.
      console.debug("Work tracking analytics event could not be recorded.", error);
      return null;
    }
  },

  getSummary: async (params = {}) => {
    const response = await api.get("/work-tracking-analytics/summary", { params });
    return response.data;
  },

  getUsers: async (params = {}) => {
    const response = await api.get("/work-tracking-analytics/users", { params });
    return response.data;
  },

  getUserEvents: async (tenantId, userId, params = {}) => {
    const encodedTenantId = encodeURIComponent(tenantId);
    const encodedUserId = encodeURIComponent(userId);
    const response = await api.get(
      `/work-tracking-analytics/users/${encodedTenantId}/${encodedUserId}/events`,
      { params }
    );
    return response.data;
  },
};

export default WorkTrackingAnalyticsService;
